module.exports = __webpack_public_path__ + "static/portfolio-5-bdf2e3b14fa683b5b55afe71ec23c3c4.jpg";